<template>
  <div class="l_registration" :class="{ is_ipad: isIPad }">
    <template v-if="this.registerInfo.length > 0">
      <header>{{ this.title }}</header>
      <p class="alert">
        プロフィールを全て入力すると<br />
        スタンプが1つもらえます。
      </p>
      <div class="l_container">
        <div
          class="content"
          v-for="(item, index) in this.registerInfo"
          :key="`form_${index}`"
        >
          <div class="right-content">
            <p class="title">
              {{ item.name }} (任意)
              {{ formNotes(item.register_manage_id) }}
            </p>
            <!-- Selectbox -->
            <template v-if="__checkInputType(item.input_type, '0')">
              <select-box
                :list="item.items"
                :registerId="item.register_manage_id"
                @change="__onChangeSelectbox"
                @focus="__onFocusSelectBox"
              />
            </template>

            <!-- テキスト入力 TODO: ダミー -->
            <template v-if="__checkInputType(item.input_type, '1')">
              <input type="text" />
            </template>

            <!-- 都道府県  -->
            <template v-if="__checkInputType(item.input_type, '2')">
              <select-box
                :list="prefectures"
                :registerId="item.register_manage_id"
                @change="__onChangePrefecture"
                @focus="__onFocusPrefecture"
              />
            </template>

            <!-- 市区町村 -->
            <template v-if="__checkInputType(item.input_type, '3')">
              <select-box
                :list="currentCities"
                :registerId="item.register_manage_id"
                @change="__onChangeCity"
                @focus="__onFocusCity"
              />
            </template>
          </div>
        </div>
        <div class="text-bottom">
          <p>
            香の川製麺の
            <a class="c_link" @click="callTermsOfService">利用規約</a>
            および
            <a class="c_link" @click="callPrivacyPolicy">個人情報保護方針</a>
            をご確認の上、設定してください。
          </p>
        </div>
        <div class="button-action">
          <a @click="this.tapSubmit"><p>設定する</p></a>
        </div>
      </div>
    </template>
    <!-- エラーパネル -->
    <template v-if="isError">
      <error-popup
        :title="errorTitle"
        :message="errorMsg"
        :label="'もう一度試す'"
        @submit="() => tapRetryFetch()"
        @close="() => tapErrorClose()"
      />
    </template>
    <!-- 紹介成功 -->
    <template v-if="isInvitationSuccess">
      <alert-invitation-success
        :point="numStamps"
        :inviterPoint="inviterNumStamps"
        :inviterExpireDays="inviterExpireDays"
        @close="() => this.endRegister(this.userId)"
      />
    </template>
    <!-- 紹介失敗 -->
    <template v-if="isInvitationFailure">
      <alert-invitation-get-failure
        :inviteeExpireDays="inviteeExpireDays"
        @close="() => this.endRegister(this.userId, false)"
      />
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment' // source https://www.npmjs.com/package/moment
import { en, ja } from 'vuejs-datepicker/dist/locale' // source https://github.com/charliekassel/vuejs-datepicker
import SelectBox from '@/components/CSelectBox.vue'
import DateFormatter from '../utils/DateFormatter.js'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import app from '../constant/app_config.js'
import { ErrorCode, ErrorMessage } from '@/api/APIClient'
import { FactoryTrack } from '../constant/firebase'
import AlertInvitationSuccess from '@/components/Modal/AlertInvitationSuccess'
import AlertInvitationGetFailure from '@/components/Modal/AlertInvitationGetFailure'
import '@/styles/color.css'

export default {
  name: 'Registration',
  components: {
    AlertInvitationGetFailure,
    AlertInvitationSuccess,
    SelectBox,
    ErrorPopup
  },
  data() {
    return {
      title: 'プロフィール設定',
      currentCities: [],
      isAddHidingYear: false,
      birthday: '01/01',
      user: {}, // 選択されたデータはここに入ります。
      en: en,
      ja: ja,
      isError: false,
      errorMsg: '',
      errorTitle: '',
      errorType: '',
      debugToken: '',
      debugParam: '',
      debugError: '',
      isIPad: false,
      isInvitationSuccess: false,
      isInvitationFailure: false,
      numStamps: 0,
      inviterNumStamps: 0,
      inviterExpireDays: 0,
      inviteeExpireDays: 0
    }
  },
  watch: {
    userId: function(value) {

      this.userId = value
      if (this.invitationData == null) {
        this.endRegister(value)
        return
      }
      this.numStamps = this.invitationData.num_stamps
      this.inviterNumStamps = this.invitationData.inviter_num_stamps
      this.inviterExpireDays = this.invitationData.inviter_expire_days
      this.inviteeExpireDays = this.invitationData.invitee_expire_days
      if (this.invitationData.error != null) {
        this.isInvitationFailure = true
        return
      }
      this.isInvitationSuccess = true
    }
  },
  async created() {
    document.title = this.title
    // ローケーションデータの読み込み
    await this.action_FetchLocation()
    // 登録項目を取得
    await this.didFetchRegisterInfo()
    // 初期の市区町村設定
    this.currentCities = this.cities[this.prefectures[0].item]
    this.actionSetSelectedMonth('')
    this.actionRequestLocationPermIfNeeded()
  },
  mounted: function() {

    const ua = window.navigator.userAgent
    if (ua.indexOf('iPhone') >= 0 && window.innerWidth < 375) {
      this.isIPad = true
    }
  },
  computed: {
    ...mapGetters({
      registerInfo: 'User/registerInfo',
      userId: 'User/userId',
      prefectures: 'Location/prefectures',
      cities: 'Location/cities',
      registered: 'User/registered',
      invitationData: 'User/invitationData',
      lineUid: 'ThirdPartyUid/lineUid',
      siwaUid: 'ThirdPartyUid/siwaUid'
    })
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('User', [
      'actionFetchRegisterInfo',
      'actionRegisterUserData'
    ]),
    ...mapActions('Location', ['action_FetchLocation']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionCallTermsOfService',
      'actionCallPrivacyPolicy',
      'actionSendRegisterParams',
      'actionRequestLocationPermIfNeeded'
    ]),
    ...mapActions('FormRegisterUser', ['actionSetSelectedMonth']),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('ThirdPartyUid', ['setLineUid', 'setSIWAUid']),
    async didFetchRegisterInfo() {
      const accTime = new DateFormatter().format(new Date())
      try {
        window.receivedToken = payload => {
          const json = JSON.parse(payload)
          this.debugToken = json
          this.fetchRegisterInfo(json.app_token, accTime, json.device_id)
          window.receivedToken = null
        }
        this.actionRequestToken({ apiType: '1', acc_time: accTime })
      } catch (e) {
        console.log(e)
        this.errorTitle = 'エラー' + ErrorCode.CODE_ERROR_TOKEN
        this.errorMsg = ErrorMessage.MSG_ERROR_TOKEN
        this.isError = true
        this.errorType = 'token'
        this.debugError = String(e)
      }
    },
    /**
     * 登録情報をAPIから取得
     * @param {String} token
     * @param {String} accTime
     * @param {string} deviceId
     */
    async fetchRegisterInfo(token, accTime, deviceId) {
      this.debugToken = `token: ${token}\naccTime: ${accTime}\ndeviceId: ${deviceId}`
      this.actionToggleLoading(true)
      try {
        await this.actionFetchRegisterInfo({
          token: token,
          accTime: accTime,
          deviceId: deviceId
        })
      } catch (e) {
        console.log(e)
        this.debugError = String(e)
        // TODO: エラーアラート追加
        this.errorTitle = 'エラー' + e.code
        this.errorMsg = e.message
        this.isError = true
        this.errorType = 'fetch'
      }
      setTimeout(() => {
        this.actionToggleLoading(false)
      }, 1000)
    },
    // 最新データを取得
    tapRetryFetch() {
      this.trackEvent(FactoryTrack.createErrorRetry())
      switch (this.errorType) {
        case 'submit':
          this.tapSubmit()
          break
        case 'token':
          this.$router.go()
          break
        case 'fetch':
          this.didFetchRegisterInfo()
          break
        default:
          this.$router.go()
          break
      }
    },
    // エラーポップアップ閉じるボタン
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
      this.isError = false
      if (this.errorType === 'fetch') {
        this.didFetchRegisterInfo()
      }
    },
    /**
     * 登録ボタンタップ
     */
    tapSubmit() {
      try {
        this.trackEvent(FactoryTrack.createAccount()) // Tacking
      } catch (e) {
        console.log(e)
      }

      this.actionToggleLoading(true)
      const accTime = new DateFormatter().format(new Date())
      const params = { apiType: '2', acc_time: accTime }
      Object.keys(this.user).forEach(key => {
        params[`register_manage_${key}`] = this.user[key]
      })
      if (this.siwaUid) {
        params['siwa_uid'] = this.siwaUid
      }
      if (this.lineUid) {
        params['line_uid'] = this.lineUid
      }
      console.log(params)
      console.log(this.user)
      try {
        window.receivedToken = async payload => {
          const json = JSON.parse(payload)
          await this.__postUserData(json)
          this.actionToggleLoading(false)
          window.receivedToken = null
        }
        this.actionRequestToken(params)
      } catch (e) {
        params['app_token'] = ''
      }
    },
    // 利用規約を呼び出す
    async callTermsOfService() {
      try {
        this.trackEvent(FactoryTrack.createTermsOfService())
        this.actionCallTermsOfService()
      } catch (e) {
        console.warn(e)
      }
    },
    // プライバシーポリシー画面を呼び出す
    async callPrivacyPolicy() {
      try {
        this.trackEvent(FactoryTrack.createPrivacyPolicy())
        this.actionCallPrivacyPolicy()
      } catch (e) {
        console.warn(e)
      }
    },
    /**
     * ユーザーデータを保存
     */
    async __postUserData(params) {
      console.log('*** post user data ***')
      console.log(params)
      try {
        await this.actionRegisterUserData({ params: params, user: this.user })
      } catch (e) {
        if (e.code) {
          this.errorTitle = 'エラー' + e.code
          this.errorMsg = e.message
          console.log('ユーザー登録に失敗しました')
        } else {
          this.errorTitle = 'エラー' + ErrorCode.CODE_ERROR_NETWORK
          this.errorMsg = ErrorMessage.MSG_ERROR_NETWORK
        }
        this.isError = true
        this.errorType = 'submit'
      }
    },
    formNotes(registerManageId) {
      let notes = ''
      if (registerManageId === '67' || registerManageId === '68') {
        const monthOrDay = { '67': '月', '68': '日' }
        notes = `※生まれた${monthOrDay[registerManageId]}は初回入力後、変更できません。`
      }
      return notes
    },
    /**
     * インプットタイプ調べる
     * @param {String} managed_id
     * @param {int} target
     */
    __checkInputType(inputType, targetInputType) {
      return inputType === targetInputType
    },
    /**
     * 生年月で利用する、Dateフォーマット
     */
    __customFormatter(date) {
      return moment(date).format('MM/DD')
    },
    /**
     * セレクトボックスのコールバック
     */
    __onChangeSelectbox(data) {
      console.warn(data)
      this.__setUserData(data.registerId, data.item_id)
      console.log('**** register id ****')
      console.log(data.registerId)
      if (data.registerId === app.api.month) {
        this.actionSetSelectedMonth(data.item)
      }
    },
    /**
     * select box focus
     */
    __onFocusSelectBox(data) {
      this.__setUserData(data.registerId, data.item_id)
      if (data.registerId === app.api.month) {
        this.actionSetSelectedMonth(data.item)
      }
    },
    /**
     * 都道府県選択
     */
    __onChangePrefecture(data) {
      console.warn(data)
      this.__setUserData(data.registerId, data.item_id)
      this.currentCities = this.cities[data.item]
      if (!this.currentCities) {
        this.__setUserData('64', '')
      }
    },
    /**
     * prefecture focus
     */
    __onFocusPrefecture(data) {
      this.__setUserData(data.registerId, data.item_id)
    },
    /**
     * 市町村選択
     */
    __onChangeCity(data) {
      console.warn(data)
      this.__setUserData(data.registerId, data.item_id)
    },
    /**
     * city focus
     */
    __onFocusCity(data) {
      this.__setUserData(data.registerId, data.item_id)
    },
    /**
     * 生年月取得
     */
    __onSelectedBirth(manageId, data) {
      this.__setUserData(manageId, moment(data).format('MM/DD'))
    },
    /**
     * ユーザーデータを登録する
     * @param {String} registerId
     * @param {String} value
     */
    __setUserData(registerId, value) {
      // here if value is empty, registerInfo api will return error
      if (value.length > 0) {
        this.user[registerId] = value
      } else {
        delete this.user[registerId]
      }
    },
    endRegister(userId, result = true) {
      if (result) {
        this.trackEvent(FactoryTrack.createInvitationSuccessClose())
      } else {
        this.trackEvent(FactoryTrack.createInvitationFailureClose())
      }

      // TODO: 投稿データを全て調べる
      console.log('watch userID ', userId)
      // check user data.  complete or not complete
      let isComplete = '0' // 0: false 1: true
      if (Object.keys(this.user).length === this.registerInfo.length) {
        isComplete = '1'
      }
      this.setSIWAUid('')
      this.setLineUid('')

      this.actionSendRegisterParams({
        isComplete: isComplete,
        userId: userId,
        isUpdate: '0'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.l_registration {
  background-color: #ffffff;
  width: 100%;
  min-height: 100%;
  padding-bottom: 5px;
  text-align: center;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
}

.l_registration.is_ipad {
  padding: 20px 0;
}

.l_registration header {
  font-family: HiraKakuPro-W6;
  font-size: 15px;
  font-weight: bold;
  line-height: 1;
  color: #333333;
  padding: 15px 81px 12px;
  border-bottom: 1px #dddddd solid;
}

.l_registration .l_container {
  margin: 0px 12px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.l_registration .l_container .top-header {
  font-family: HiraKakuPro-W3;
  font-size: 12px;
  line-height: 1.67;
  color: #333333;
  justify-content: center;
  margin: 8px 12px 8px 12px;
  padding: 6px 12px 6px 12px;
}

.l_registration .l_container .content {
  height: 54px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  &:nth-of-type(1) {
    margin-top: 20px;
  }
  &:nth-of-type(n + 2) {
    box-shadow: inset 0 1px 0 0 #dddddd;
  }
}

.l_registration .l_container .content .right-content {
  width: 100%;
  align-content: left;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 12px 15px 5px 15px;
}

.l_registration .l_container .content .right-content .title {
  margin-bottom: 6px;
  font-family: 'HiraKakuPro-W3';
  font-size: 10px;
  line-height: 1;
  color: #777777;
}

.l_registration .l_container .content .right-content select {
  font-family: HiraKakuPro-W6;
  background-color: #ffffff;
  font-size: 14px;
  width: 100%;
  height: 22px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  border: none;
  font-weight: bold;
  letter-spacing: 1px;
}

.l_registration .l_container .text-bottom {
  font-family: 'HiraKakuPro-W3';
  font-size: 12px;
  line-height: 1.67;
  color: #333333;
  padding: 20px 34px 12px 34px;
}
.l_registration .l_container .text-bottom a {
  color: #333333;
}

.l_registration .l_container .text-bottom .text-bold {
  font-family: 'HiraKakuPro-W6';
  font-size: 12px;
  line-height: 1.67;
  color: #602209;
  font-weight: bold;
  padding-top: 16px;
}

.l_registration .button-action {
  border-radius: 6px;
  width: 249px;
  height: 43px;
  background-color: var(--accent-color);
  padding: 14px 14px;
  margin: auto;
}

.l_registration .l_container .button-action p {
  font-family: 'HiraKakuPro-W6';
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  color: #ffffff;
  padding: 1px;
}

.vdp-datepicker > input {
  border: none !important;
  font-weight: bold;
}

@media only screen and (max-width: 360px) {
  .l_registration .l_container .top-header {
    font-family: 'HiraKakuPro-W3';
    font-size: 12px;
    line-height: 1.67;
    color: #333333;
    justify-content: center;
    margin: 8px 12px 8px 12px;
    padding: 6px 5px 6px 5px;
  }
}

/* リンクテキストスタイル */
.c_link {
  text-decoration: underline;
}
</style>

<style>
/* Datepickerのスタイル */
.vdp-datepicker input {
  font-family: 'HiraKakuPro-W6';
  font-size: 14px;
  outline: none;
  width: 100%;
  background: transparent;
  border: none;
}

.vdp-datepicker__calendar .cell.selected {
  background-color: #602209;
  color: #ffffff;
}

.vdp-datepicker__calendar .day__month_btn.up {
  position: relative;
  left: -25px;
}
.vdp-datepicker__calendar .day__month_btn.up > span {
  position: absolute;
  background-color: white;
  overflow: hidden;
  width: 50px;
}

.vdp-datepicker__calendar .cell.selected:hover {
  background-color: #602209;
  color: #ffffff;
}
.alert {
  background-color: #f6c143;
  padding: 4px 0;
  display: block;
  font-size: 12px;
}
</style>
